import React from "react";

const JobteaserLogo = () => (
    <span className="logo jobteaser-logo">
        <svg
            width="54"
            height="54"
            viewBox="0 0 54 54"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="jobteaser">
                <path
                    id="Vector"
                    d="M52.8497 26.9608C52.8497 41.0242 41.4499 52.4216 27.3873 52.4216C13.3246 52.4216 1.9248 41.0242 1.9248 26.9608C1.9248 12.8974 13.3295 1.5 27.3921 1.5C41.4548 1.5 52.8546 12.8974 52.8546 26.9608H52.8497Z"
                    stroke="#0058ab"
                    strokeWidth="2"
                />

                <g id="Vector_2" transform="translate(14.8, 17.0) scale(0.05)">
                    <path
                        d="M177.8,209.8l177.9,286L0,209.8H177.8z
                        M139.9,68.1L283.3,299l145.7-0.2L288.2,68.1H139.9z
                        M444.5,0H297.7l73,124.2L444.5,0z"
                        fill="#0058ab"
                    />
                </g>
            </g>
        </svg>
    </span>
);

export default JobteaserLogo;
